/* global Sys, Core, NetEntExtend, Platform, Services */
Sys.ns("Core");

/**
 * The NetEnt Extend controller.
 *
 * @class Core.NetEntExtendController
 * @extends Core.Controller
 */
Core.NetEntExtendController = {

    USE_LOGGING: false,

    /**
     * @inheritdoc
     */
    constructor: function() {
        Core.NetEntExtendController.superclass.constructor.apply(this, arguments);
    },

    /**
     * @inheritdoc
     */
    init: function() {
        var me = this;

        Core.NetEntExtendController.superclass.init.apply(me, arguments);

        // Array with methods to be executed when entering idle state
        me.onEnteringIdleState = [];

        me.setupAPI();
    },

    /**
     * @inheritdoc
     */
    setupEvents: function() {
        var me = this;

        me.on({
            "notify:stateHandler.enteringIdleState": me.enteringIdleState,
            "notify:stateHandler.leavingIdleState": me.leavingIdleState,

            "notify:netEntExtendEvents.eventTriggered": me.sendMessage,
            "notify:responseParser.reloadBalanceResponseParsed": me.onReloadBalanceResponse,
            "notify:serverManager.reloadBalanceFailed": me.onReloadBalanceFailed,

            "notify:featureSplash.showing": me.onFeatureSplashShowing,
            "notify:featureSplash.closed": me.onFeatureSplashClosed,

            "notify:gameModeChanged": me.onGameModeChanged,
            "request:NetEntExtend.newMessage": me.handleIncomingMessage
        });
    },

    /**
     * Defines the getters, setters and calls.
     *
     * @private
     * @returns {void}
     */
    setupAPI: function() {
        var me = this,
            useRestricted = me.model.readData("useRestricted"),
            api = (useRestricted === true) ? NetEntExtend.API.Restricted : NetEntExtend.API;

        me.API = {
            get: api.Getters,
            set: api.Setters,
            call: api.Calls
        };
    },

    /**
     * Executes all the methods stored in the array when entering idle state.
     *
     * @private
     * @returns {void}
     */
    enteringIdleState: function() {
        var me = this;

        me.onEnteringIdleState.forEach(function(func) {
            func.apply(me, arguments);
        });

        // Reset the array (we want the lock method to always be executed so add it again)
        me.onEnteringIdleState = [];

        me.model.storeData("inIdleState", true);
    },

    /**
     * Called when leaving idle state.
     *
     * @private
     * @returns {void}
     */
    leavingIdleState: function() {
        var me = this;

        me.model.storeData("inIdleState", false);
        me.model.storeData("reloadBalanceSpin", true);
    },

    /**
     * Matches an incoming message (request) to either a get, set or call method.
     *
     * @private
     * @returns {void}
     */
    handleIncomingMessage: function() {
        var me = this,
            messageType = arguments[0],
            callId = arguments[1],
            actionName = arguments[2],
            action;

        // Check if we have the minimum required parameters (name, callId, action) and that they are of the correct type
        if (arguments.length < 3 || typeof messageType !== "string" || !Sys.isNumber(callId) || typeof actionName !== "string") {
            me.error(arguments, me.model.ERROR_CODES.WRONG_NUMBER_OF_ARGUMENTS);
        }
        // Check if messageType and action exist in the available API
        else if (!Sys.isDefined(me.API[messageType]) || !Sys.isDefined(me.API[messageType][actionName])) {
            me.error(arguments, me.model.ERROR_CODES.FUNCTIONALITY_NOT_AVAILABLE);
        }
        else {
            // The action exist
            action = me.API[messageType][actionName];

            // Is the action available on the current platform?
            if ((Platform.isDesktopDevice && action.platforms.indexOf("desktop") === -1) ||
                ((Platform.isMobileDevice || Platform.isTabletDevice) && action.platforms.indexOf("mobile") === -1)) {
                me.error(arguments, me.model.ERROR_CODES.FUNCTIONALITY_NOT_AVAILABLE);
            }
            // Is the action available in the current state?
            else if (!action.isAvailable.apply(me, arguments)) {
                me.error(arguments, me.model.ERROR_CODES.NOT_AVAILABLE_IN_CURRENT_STATE);
            }
            // Does the action has the correct number of arguments?
            else if (!action.validateNumArguments.apply(me, arguments)) {
                me.error(arguments, me.model.ERROR_CODES.WRONG_NUMBER_OF_ARGUMENTS);
            }
            // Are the arguments valid?
            else if (!action.validateArguments.apply(me, arguments)) {
                me.error(arguments, me.model.ERROR_CODES.ILLEGAL_ARGUMENT);
            }
            else {
                // Everything checked out, save the function
                try {
                    /* DEBUG_START */
                    if (this.USE_LOGGING) {
                        console.info("Extend :: perform API action :: messageType: " + messageType + " actionName:" + actionName);
                    }

                    /* DEBUG_END */
                    action.func.apply(me, arguments);
                }
                catch (e) {
                    me.error(arguments, me.model.ERROR_CODES.UNKNOWN_ERROR);
                }
            }
        }
    },

    /**
     * The callback that runs if a request succeeded.
     *
     * @private
     * @returns {void}
     */
    success: function() {
        var me = this,
            response = me.getResponseArguments.apply(me, arguments);

        me.sendMessage(["success", response.callId].concat(response.rest));
    },

    /**
     * The callback that runs if a request fails.
     *
     * @private
     * @param {Array} args The argument array.
     * @param {number} errorcode The type of error that was triggered.
     * @param {*} [errorArgument] Any extra argument to supply to the GI error handler.
     * @returns {void}
     */
    error: function(args, errorcode, errorArgument) {
        var me = this,
            response = me.getResponseArguments.apply(me, args);

        me.sendMessage(["error", response.callId, errorcode, errorArgument]);
    },

    /**
     * Sends a response through the Post Message API.
     *
     * @private
     * @param {Array} response The response parameters.
     * @returns {void}
     */
    sendMessage: function(response) {
        var argString = "";

        /* DEBUG_START */
        if (this.USE_LOGGING) {
            Sys.each(response, function(value) {
                argString += value + " ";
            });
            console.info("Extend :: sendMessage :: " + argString);
        }

        /* DEBUG_END */
        this.fireEvent("request:postman.sendMessage", response);
    },

    /**
     * Gets response arguments.
     *
     * @private
     * @returns {Object} Response arguments.
     */
    getResponseArguments: function() {
        var argArray = Array.prototype.slice.call(arguments),
            callId = argArray[1],
            rest = argArray.splice(3);

        return { callId: callId, rest: rest };
    },

    /**
     * Append parameters to an argument array.
     *
     * @private
     * @param {Array} args The arguments.
     * @param {*} paramsToAdd The parameters to add (can be a single value or an array of values).
     * @returns {Array} Argument.
     */
    addParamsToArgument: function(args, paramsToAdd) {
        var argArray = Array.prototype.slice.call(args);

        if (Sys.isArray(paramsToAdd)) {
            paramsToAdd.forEach(function(value) {
                argArray.push(value);
            });
        }
        else {
            argArray.push(paramsToAdd);
        }

        return argArray;
    },

    /**
     * Handles the response from the reload balance request. Updates the cash balance.
     *
     * @private
     * @param {Object} response Response.
     * @returns {void}
     */
    onReloadBalanceResponse: function(response) {
        var me = this,
            args = me.model.readData("reloadBalanceArguments"),
            spinStarted = me.model.readData("reloadBalanceSpin"),
            credit = response.credit;

        // Send a busy instead of balance if a spin has been made since the call was done
        if (spinStarted) {
            me.success.apply(me, me.addParamsToArgument(args, "busy"));
        }
        else if (Sys.isNumber(credit)) {
            Services.moneyManager.setBalance(credit);
            me.success.apply(me, me.addParamsToArgument(args, credit));
        }
    },

    /**
     * Runs error callback if the reload balance request fails.
     *
     * @private
     * @returns {void}
     */
    onReloadBalanceFailed: function() {
        var me = this,
            args = me.model.readData("reloadBalanceArguments");

        me.error(args, me.model.UNKNOWN_ERROR);
    },

    /**
     * Gets called when the feature splash is showing.
     *
     * @returns {void}
     */
    onFeatureSplashShowing: function() {
        this.model.storeData("featureSplash.showing", true);
    },

    /**
     * Gets called when the feature splash has closed.
     *
     * @returns {void}
     */
    onFeatureSplashClosed: function() {
        this.model.storeData("featureSplash.showing", false);
    },

    /**
     * Starts a round.
     *
     * @private
     * @returns {void}
     */
    startRound: function() {
        Services.gameRound.start();
    },

    /**
     * Stores the new game mode.
     *
     * @private
     * @param {*} gameMode New game mode.
     * @returns {void}
     */
    onGameModeChanged: function(gameMode) {
        this.model.storeData("gameMode", gameMode);
    }
};

Core.NetEntExtendController = Sys.extend(Core.Controller, Core.NetEntExtendController, "Core.NetEntExtendController");
